import { useEffect } from 'react';
import { getSortField, getSortValue, sortKey } from '../../../../../../features/table/helpers';
import { tzOffset } from '../../../../../../helpers/date-time';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useCheckInCheckOutStore } from '../../../../../../store/use-check-in-check-out-store';
import { SortType } from '../../../../../../types/props';

const defaultParams = {
  since_id: 0,
  is_by_company: true,
  n: 1000,
  offset: -tzOffset,
  with_archive: true,
};

export const useCheckInCheckOutHistoryModal = () => {
  const { checkinsHistory, isLoadingHistoryFetch, fetchCheckInCheckOutHistory, paginationHistory } =
    useCheckInCheckOutStore();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();

  const historyDate = params.historyDate;
  const historyEmployee = params.historyEmployee;
  const historyAuthor = params.historyAuthor;
  const historyReason = params.historyReason;
  const page = params['checkins-history_page'];
  const pageSize = params['checkins-history_pageSize'];
  const sort = params[sortKey];
  const sortField = getSortField(sort);
  const sortDirection = getSortValue(sort) as SortType;

  useEffect(() => {
    fetchCheckInCheckOutHistory({
      ...defaultParams,
      historyDate,
      historyEmployee,
      historyAuthor,
      historyReason,
      field: sortField,
      dir: sortDirection,
      page,
      page_size: pageSize,
    });
  }, [
    historyDate,
    historyEmployee,
    historyAuthor,
    historyReason,
    sortField,
    sortDirection,
    page,
    pageSize,
  ]);

  return { checkinsHistory, isLoadingHistoryFetch, paginationHistory };
};
